import api from "../../api";


export function addEvent(payload) {
  return api.post("event_tracking", payload);
}